/**
 * The type of the Redux action which is dispatched when an interpreter request is made.
 */
export const REQUEST_INTERPRETER = 'REQUEST_INTERPRETER';
/**
 * The type of the Redux action which is dispatched when an interpreter request is cancelled.
 */
export const CANCEL_REQUEST = 'CANCEL_REQUEST';
/**
 * The type of the Redux action which is dispatched when a new interpreter request is received.
 */
export const INTERPRETER_REQUEST_RECEIVED = 'INTERPRETER_REQUEST_RECEIVED';
/**
 * The type of the Redux action which is dispatched when an interpreter request is accepted.
 */
export const REQUEST_ACCEPTED = 'REQUEST_ACCEPTED';
/**
 * The type of the Redux action which is dispatched when an interpreter request is declined.
 */
export const REQUEST_DECLINED = 'REQUEST_DECLINED';
/**
 * The type of the Redux action which is dispatched when a match is found.
 */
export const MATCH_FOUND = 'MATCH_FOUND';
/**
 * The type of the Redux action which is dispatched when a meeting is initiated.
 */
export const MEETING_INITIATED = 'MEETING_INITIATED';
/**
 * The type of the Redux action dispatched when an interpreted call ends or is
 * locally reconciled as stale.
 */
export const INTERPRETED_CALL_ENDED = 'INTERPRETED_CALL_ENDED';
/**
 * The type of the Redux action which is dispatched when the queue status is updated.
 */
export const QUEUE_STATUS_UPDATE = 'QUEUE_STATUS_UPDATE';
/**
 * The type of the Redux action which is dispatched when the queue connection status changes.
 */
export const QUEUE_CONNECTION_CHANGED = 'QUEUE_CONNECTION_CHANGED';
/**
 * The type of the Redux action dispatched when the queue service rejects a request.
 */
export const QUEUE_SERVICE_ERROR = 'QUEUE_SERVICE_ERROR';
/**
 * Server-decided features from auth_success, e.g. externalMeetingVrs
 * (vrs-server/ws/auth-handlers.js). Turning one on needs no app rebuild.
 */
export const QUEUE_CAPABILITIES_UPDATED = 'QUEUE_CAPABILITIES_UPDATED';
/**
 * The interpreter for the client's own Zoom/Meet/Teams/Webex meeting was
 * matched, or reported entering / identifying the client in it.
 */
export const EXTERNAL_MEETING_CALL_UPDATED = 'EXTERNAL_MEETING_CALL_UPDATED';
/**
 * The external-meeting call ended.
 */
export const EXTERNAL_MEETING_CALL_ENDED = 'EXTERNAL_MEETING_CALL_ENDED';
/**
 * The interpreter's in-call "Pause after this call" choice changed.
 */
export const SET_PAUSE_AFTER_CALL = 'SET_PAUSE_AFTER_CALL';
/**
 * The interpreter's wrap-up between calls began, changed phase or ended.
 */
export const INTERPRETER_WRAP_UP_UPDATED = 'INTERPRETER_WRAP_UP_UPDATED';
/**
 * The server confirmed this interpreter's queue availability (status_updated).
 */
export const INTERPRETER_AVAILABILITY_CHANGED = 'INTERPRETER_AVAILABILITY_CHANGED';
/**
 * Calendar meeting reminders (phase 2): replaced from the API, added from the
 * socket, removed when used or dismissed.
 */
export const MEETING_REMINDERS_SET = 'MEETING_REMINDERS_SET';
export const MEETING_REMINDERS_ADDED = 'MEETING_REMINDERS_ADDED';
export const MEETING_REMINDER_REMOVED = 'MEETING_REMINDER_REMOVED';
